export const RecipientEmailSelector = Backbone.Marionette.Layout.extend({
    template: '#tpl_report_recipient_email_selector',
    className: 'card',

    title: null, // string
    userEmail: null, // string
    locationEmail: null, // string
    emailIsValid: null, // boolean

    saveEmailAddress: null, // function
    handleValidEmail: null, // function
    handleInvalidEmail: null, // function
    handleShowLegend: null, // function
    setLocationEmailByDefault: false, // boolean

    showLegend: true,

    events: {
        'click .show_email_selector_legend': 'showSendEmailToLegend',
        'click .email_radio': 'toggleCustomEmailInput',
        'change .custom_email_input': 'handleEmailChange'
    },

    initialize: function (options) {
        options = options || {};
        this.validateRequiredArguments(options);
        $.extend(this, options);
    },

    validateRequiredArguments: function (options) {
        const {
            userEmail,
            locationEmail,
            title,
            saveEmailAddress,
            handleValidEmail,
            handleInvalidEmail,
            handleShowLegend
        } = options;
        const requiredFields = [
            userEmail,
            locationEmail,
            title,
            saveEmailAddress,
            handleValidEmail,
            handleInvalidEmail,
            handleShowLegend
        ];

        if (requiredFields.some(_.isUndefined)) {
            throw new Error(
                'Programmer Error: RecipientEmailSelector must have a userEmail, locationEmail, title, saveEmailAddress, handleValidEmail, handleInvalidEmail and handleShowLegend'
            );
        }
    },

    templateHelpers: function () {
        return {
            user_email: this.userEmail,
            location_email: this.locationEmail,
            title: this.title,
            show_legend: this.showLegend,
            location_email_by_default: this.setLocationEmailByDefault,
            user_email_checked: !this.setLocationEmailByDefault || !this.locationEmail
        };
    },

    showSendEmailToLegend: function (event) {
        this.handleShowLegend(event);
    },

    toggleCustomEmailInput: function (event) {
        const selectedEmailRadioValue = event.target.value;
        const emailInput = this.$('.custom_email_input');
        const EMAIL_ACTIONS = {
            custom: () => {
                emailInput.prop('disabled', false);
                emailInput.removeClass('disabled');
                this.setEmailAddress(emailInput.val());
            },
            location: () => {
                emailInput.prop('disabled', true);
                emailInput.addClass('disabled');
                this.setEmailAddress(this.locationEmail);
            },
            user: () => {
                emailInput.prop('disabled', true);
                emailInput.addClass('disabled');
                this.setEmailAddress(null);
            }
        };

        EMAIL_ACTIONS[selectedEmailRadioValue]();
    },

    handleEmailChange: function (event) {
        this.setEmailAddress(event.target.value);
    },

    setEmailAddress: function (email) {
        const selectedEmailRadio = this.$('.email_radio:checked');
        const isUserEmail = selectedEmailRadio.val() === 'user';

        this.validateCustomEmail(email);

        if (isUserEmail) {
            this.saveEmailAddress(null);
            this.handleValidEmail();
            return;
        }

        const isValidEmail = this.isValidEmail(email);

        if (isValidEmail) {
            this.saveEmailAddress(email);
            this.handleValidEmail();
        } else {
            this.handleInvalidEmail();
        }
    },

    validateCustomEmail(email) {
        const customEmailInput = this.$('.custom_email_input');
        const customEmail = customEmailInput.val();

        const isValidEmail = this.isValidEmail(customEmail);

        if (!customEmail?.trim() || isValidEmail) {
            customEmailInput.removeClass('invalid');
            return;
        }

        if (!isValidEmail) {
            customEmailInput.addClass('invalid');
            return;
        }
    },

    isValidEmail: function (email) {
        // $f.utils.validate_email accepts emails separated by comma, but we only want one email.
        // We need to validate that separately
        return !email.includes(',') && $f.utils.validate_email(email);
    }
});
